import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { Observable, catchError, map, throwError } from 'rxjs';

import {
  LIST_OWN_EXTERNAL_PROPERTIES,
  MY_DEALS_METRICS,
} from '@graphql/queries/my-deals.queries';
import { WITHDRAW_EXTERNAL_PROPERTY } from '@graphql/mutations/my-deals.mutations';
import {
  IListOwnExternalPropertiesData,
  IMyDealsMetricsData,
  IWithdrawExternalPropertyInput,
  IWithdrawExternalPropertyResult,
} from '@shared/models/my-deals';

@Injectable({
  providedIn: 'root',
})
export class MyDealsService {
  constructor(private apollo: Apollo) {}

  listOwnExternalProperties(): Observable<IListOwnExternalPropertiesData> {
    return this.apollo
      .query({
        query: LIST_OWN_EXTERNAL_PROPERTIES,
      })
      .pipe(map((result) => result.data));
  }

  myDealsMetrics(): Observable<IMyDealsMetricsData> {
    return this.apollo
      .query({
        query: MY_DEALS_METRICS,
      })
      .pipe(map((result) => result.data));
  }

  withdrawExternalProperty(
    input: IWithdrawExternalPropertyInput
  ): Observable<IWithdrawExternalPropertyResult> {
    return this.apollo
      .mutate({
        mutation: WITHDRAW_EXTERNAL_PROPERTY,
        variables: input,
      })
      .pipe(
        map((result) => result.data as IWithdrawExternalPropertyResult),
        catchError((error) => {
          return throwError(() => error);
        })
      );
  }
}
